import { render, staticRenderFns } from "./Bindphone.vue?vue&type=template&id=5c40a081&scoped=true&"
import script from "./Bindphone.vue?vue&type=script&lang=js&"
export * from "./Bindphone.vue?vue&type=script&lang=js&"
import style0 from "./Bindphone.vue?vue&type=style&index=0&id=5c40a081&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c40a081",
  null
  
)

export default component.exports